import * as React from 'react';
import { Badge, BadgeProps } from 'ui/badge/badge';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import styles from 'app/area/case/components/fact-box/fact-box.scss';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';

interface ConnectedCasesResidualRiskFactItemProps extends ComponentProps, FactItemProps  {
  badgeProps: BadgeProps;
  section?: number;
  hideRiskWeight?: boolean;
  connectedRiskWeightRest: number;
  connectedRiskAreaRest: ComplexValue<number>;
  connectedRiskTrendRest: ComplexValue<number>[];
}

export const ConnectedCasesResidualRiskFactItem = (props: ConnectedCasesResidualRiskFactItemProps) => {
  const { connectedRiskAreaRest, connectedRiskTrendRest, connectedRiskWeightRest, url, title, hideRiskWeight, linkDomain,
    urlOpenNew } = props;
  const connectedCaseResidualRiskProps = {
    title: title,
    tooltip: connectedRiskAreaRest?.description,
    text: !hideRiskWeight ? connectedRiskWeightRest : '',
    filled: false,
    backgroundColor: connectedRiskAreaRest?.backgroundColor,
    riskTrend: {
      value: connectedRiskTrendRest?.[0]?.value,
      description: connectedRiskTrendRest?.[0]?.description,
      icon: connectedRiskTrendRest?.[0]?.icon
    }
  };
  if (!connectedRiskWeightRest) {
    return null;
  }
  return (<li className={`${styles.factLink} fact-item`}>
    <FactLink id={props.componentId} section={linkDomain} classNames={styles.factLink} url={url} urlOpenNew={urlOpenNew}>
      <Badge
        {...connectedCaseResidualRiskProps}
      />
    </FactLink></li>
  );
};
